export enum UserRole {
  ADMINISTRATOR = 'administrator',
  PRACTITIONER = 'practitioner'
}

export enum UserStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  SUSPENDED = 'suspended'
}

export interface User {
  id: string;
  email: string;
  name: string;
  phoneNumber: string;
  profilePhotoKey?: string;
  role: UserRole;
  status: UserStatus;
  createdAt: string;
}

export interface AuthToken {
  accessToken: string;
  idToken: string;
  refreshToken: string;
  expiresIn: number;
}

export interface AuthState {
  user: User | null;
  token: AuthToken | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}
